import React from 'react';
import {useSelector} from 'react-redux';
import {View} from 'react-native';
import {StatusSwitcherWrapper} from '../../../visuallyImpaired/statusSwitcherWrapper';
import {useStyles} from '../../../../hooks/styles';
import {useIsDesktop} from '../../../../hooks/useIsDesktop';
import {images} from '../../../../../assets/icons';
import {contentSelector} from '../../../../../redux/selectors/resources';
import {openExternalLink, openExternalPhone} from '../../../../pipes';
import {formatPhone} from '../../../../pipes';
import {IconLink} from '../iconLink';
import {Props} from './model';

function getPhoneLabel(phoneNumber: string, isDesktop: boolean, collapsed?: boolean): string {
  if (collapsed || !isDesktop) {
    return '';
  } else {
    return formatPhone(phoneNumber);
  }
}

function getAccessibilityLabel(active: boolean, collapsed?: boolean): string {
  if (collapsed) {
    return '';
  }
  return active ? 'Обычная версия' : 'Версия для слабовидящих';
}

function getESKsiteLabel(collapsed?: boolean): string {
  return collapsed ? '' : 'Портал ЕКЖ';
}

export default ({collapsed}: Props) => {
  const content = useSelector(contentSelector());
  const isDesktop = useIsDesktop();

  const styles = useStyles(({theme}) => ({
    helpLink: {
      color: theme.header.iconsColor,
    },
    helpLinkCollapsed: {
      marginLeft: 6,
      marginRight: 10,
    },
    helpLinkFull: {
      marginLeft: 23,
      marginRight: 7,
    },
  }));
  const linkStyle = collapsed ? styles.helpLinkCollapsed : styles.helpLinkFull;

  return (
    <>
      <View style={linkStyle}>
        <IconLink
          testID='menu-phone-test-id'
          icon={images.Phone}
          iconHeight={18}
          iconWidth={18}
          label={getPhoneLabel(content.eskmoContacts.supportPhone, isDesktop, collapsed)}
          onPress={async () => {
            await openExternalPhone(content.eskmoContacts.supportPhone);
          }}
        />
      </View>
      <View style={linkStyle}>
        <StatusSwitcherWrapper
          render={({active, onPress}) => (
            <IconLink
              testID='eye-test-id'
              iconHeight={18}
              iconWidth={18}
              onPress={onPress}
              icon={images.Eye}
              label={getAccessibilityLabel(active, collapsed)}
            />
          )}
        />
      </View>
      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={[linkStyle, collapsed ? {} : {marginRight: 'auto'}]}>
        <IconLink
          testID='menu-to-portal-test-id'
          icon={images.Up}
          label={getESKsiteLabel(collapsed)}
          iconHeight={18}
          iconWidth={18}
          onPress={async () => {
            await openExternalLink(content.eskmoContacts.website);
          }}
        />
      </View>
    </>
  );
};
